import { useUser } from "@clerk/clerk-expo";
import { cacheKeys } from "@constants/cache-keys";
import { useAppStore } from "@hooks/useAppStore";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { groupExamsByCategory } from "../helpers";
import { fetchExams } from "../queries/FetchExams";

export const useExams = () => {
	const { isSignedIn } = useUser();
	const {
		app: { id: appId },
		tenant: { id: tenantId },
	} = useAppStore((store) => ({
		app: store.app,
		tenant: store.tenant,
	}));

	const result = useQuery({
		queryKey: [cacheKeys.exams],
		queryFn: () => fetchExams(tenantId, appId),
		enabled: Boolean(isSignedIn),
	});

	const exams = useMemo(() => result.data ?? [], [result.data]);
	const groupedExams = useMemo(
		() => (result.data ? groupExamsByCategory(result.data) : []),
		[result.data],
	);

	return { exams, groupedExams, ...result };
};
